<!-- THE STAGE (spec §4.1): the real home's groove-hero, unchanged from the pre-hub home —
     same markup, image, headline, lede, actions. stageExtension:true on the home
     route (app.routes.ts) drops the shell's own handoff + heading + header CTA,
     so this hero is flush below the chrome and holds the page's single <h1>.
     Only THIS wrapper breaks out of `.content`'s inline gutter (not the whole
     component, as the pre-hub home's :host did) — hub-body's own recessed band
     breaks out of that same gutter again, independently, so it renders
     full-bleed too. The breadcrumb trail is the shell's (app.component.html),
     not this template's. -->
<div class="home-bleed">
  <div data-scene="stage" class="home-stage">
    <groove-hero
      layout="split"
      src="/images/r7-1024x594.webp"
      srcset="
        /images/r7-480x278.webp   480w,
        /images/r7-640x371.webp   640w,
        /images/r7-800x464.webp   800w,
        /images/r7-1024x594.webp 1024w
      "
      sizes="(max-width: 900px) 100vw, 45vw"
      objectPosition="40% 30%"
      alt="Russ Rodgers playing his bass guitar on stage"
    >
      <h1 class="groove-type-display-lg home-hero-headline">
        Bass lessons built around what
        <em>you actually want to play.</em>
      </h1>
      <p class="home-hero-lede">
        Live, one-on-one, over Zoom, with a teacher who has
        <strong>over fifty years</strong> of professional playing. Every lesson
        is built around where you are now and where you want to get on the bass.
      </p>
      <div class="home-hero-actions">
        <a grooveAction [href]="phoneHref">Call Russ</a>
        <a grooveAction variant="ghost" [href]="emailHref">
          or send an email
        </a>
      </div>
    </groove-hero>
  </div>

  <!-- Stage → paper handoff, in paper (root) scope so
       .groove-handoff { color: var(--groove-color-bg-page) } resolves to the
       PAPER bg — overridden below to bg-surface so the wave hands off into
       hub-body's recessed band, not a lighter-paper seam above it. -->
  <div class="groove-handoff" aria-hidden="true">
    <svg viewBox="0 0 1440 110" preserveAspectRatio="none">
      <path
        fill="currentColor"
        d="M0,110 L0,70 C240,30 480,95 720,60 C960,25 1200,80 1440,45 L1440,110 Z"
      />
    </svg>
  </div>
</div>

<app-hub-body>
  <!-- Russ, the player — refinement pass #9 rebuilds this as a proper beat
       (kicker + heading, a performance photo, one line of copy, two Groove
       actions) instead of the old one-off bordered card with plain
       underlined links. Not one of the numbered hub-story-order sections,
       so it carries no jump-nav entry of its own. Projected into hub-body's
       [data-slot=band] slot, which sits right after the FAQ and before
       section 8 ("Getting set up"). -->
  <ng-container data-slot="band">
    <section
      id="russ-the-player"
      class="hub-player groove-flow"
      aria-labelledby="hub-player-heading"
    >
      <app-section-head
        kicker="When he's not teaching"
        heading="Russ, the player"
        headingId="hub-player-heading"
      />
      <!-- Copy + actions beside a stage portrait (the same two-up as the
           bio beat): Russ is the subject of this frame, where the wide band
           shots made him one figure among several (review, 2026-09-07 night). -->
      <div class="hub-player-body">
        <div class="hub-player-text groove-flow">
          <p>
            Russ has been playing bass professionally for over fifty years, in
            studios, house bands, and touring groups, and these days he is out
            most weeks around South Florida. If you want to hear what all that
            teaching is built on, come to a show.
          </p>
          <div class="hub-player-actions">
            <a grooveAction routerLink="/about/performance"
              >See where he's playing</a
            >
            <a grooveAction variant="outline" routerLink="/about/bio"
              >Read the full story</a
            >
          </div>
        </div>
        <img
          class="hub-player-photo"
          src="/images/bio-gallery/stage-red.webp"
          width="1065"
          height="1222"
          loading="lazy"
          alt="Russ Rodgers playing bass on stage under red light"
        />
      </div>
    </section>
  </ng-container>
</app-hub-body>
